export const CREATE_WORKOUT = 'WORKOUT/CREATE';
export const COMPLETE_WORKOUT = 'WORKOUT/COMPLETE';
export const GET_WORKOUT_AUDIOS = 'WORKOUT/GET_WORKOUT_AUDIOS';
export const SET_WORKOUT_AUDIOS = 'WORKOUT/SET_WORKOUT_AUDIOS';
export const SET_WORKOUT = 'WORKOUT/SET';
export const SET_LOADING_STATE = 'WORKOUT/SET_LOADING_STATE';
export const GET_WORKOUT_PLAN = 'WORKOUT/GET_WORKOUT_PLAN';
export const SET_WORKOUT_PLAN = 'WORKOUT/SET_WORKOUT_PLAN';
export const GET_WORKOUT_BY_ID = 'WORKOUT/GET_BY_ID';
